export default "__VITE_ASSET__I8W07OOF__"